var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrade(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6.375C16.5 9.0675 14.3175 11.25 11.625 11.25C11.4975 11.25 11.3625 11.2425 11.235 11.235C11.0475 8.85751 9.14249 6.95249 6.76499 6.76499C6.75749 6.63749 6.75 6.5025 6.75 6.375C6.75 3.6825 8.9325 1.5 11.625 1.5C14.3175 1.5 16.5 3.6825 16.5 6.375Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 11.625C11.25 14.3175 9.0675 16.5 6.375 16.5C3.6825 16.5 1.5 14.3175 1.5 11.625C1.5 8.9325 3.6825 6.75 6.375 6.75C6.5025 6.75 6.63749 6.75749 6.76499 6.76499C9.14249 6.95249 11.0475 8.85751 11.235 11.235C11.2425 11.3625 11.25 11.4975 11.25 11.625Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.1925 1.5H2.25C1.8375 1.5 1.5 1.8375 1.5 2.25V4.1925C1.5 4.86 2.30999 5.19749 2.78249 4.72499L4.72499 2.78249C5.18999 2.30999 4.86 1.5 4.1925 1.5Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8075 16.5002H15.75C16.1625 16.5002 16.5 16.1627 16.5 15.7502V13.8077C16.5 13.1402 15.69 12.8027 15.2175 13.2752L13.275 15.2177C12.81 15.6902 13.14 16.5002 13.8075 16.5002Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrade);
export default __webpack_public_path__ + "static/media/trade.902269453dbd4ae51d341986d1d16ce5.svg";
export { ForwardRef as ReactComponent };